module.exports = __webpack_public_path__ + "static/media/nima_play_jhali3.a71b8f52.gif";